module.exports = __webpack_public_path__ + "img/contract-75.92c85a59.svg";